import React from "react";
import { ShieldCheck, BadgeCheck } from "lucide-react";
import { cn } from "@/lib/utils";

// Identity verification of a healthcare professional (person).
export function VerifiedProfessionalBadge({ className, compact = false }) {
  return (
    <span
      data-testid="badge-verified-professional"
      title="Verified Professional — identity confirmed by MedLync"
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-sky-200 bg-sky-50 px-2 py-0.5 text-[11px] font-semibold text-sky-800",
        className
      )}
    >
      <ShieldCheck className="h-3 w-3 text-sky-600" />
      {!compact && "Verified Pro"}
    </span>
  );
}

// Editorial verification of content accuracy (post), distinct from professional identity.
export function MedLyncVerifiedBadge({ className, compact = false }) {
  return (
    <span
      data-testid="badge-medlync-verified-content"
      title="MedLync-Verified — content checked by the MedLync editorial team"
      className={cn(
        "inline-flex items-center gap-1 rounded-full border border-orange-300 bg-orange-50 px-2 py-0.5 text-[11px] font-semibold text-orange-900",
        className
      )}
    >
      <BadgeCheck className="h-3 w-3 text-medorange" />
      {!compact && "MedLync Verified"}
    </span>
  );
}

const CAT = {
  "Govt & Health": "bg-indigo-50 text-indigo-700 border-indigo-200",
  City: "bg-amber-50 text-amber-800 border-amber-200",
  Hospitals: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Management: "bg-slate-100 text-slate-700 border-slate-200",
  Opportunities: "bg-orange-50 text-orange-700 border-orange-200",
};

export function CategoryPill({ category, className }) {
  return (
    <span className={cn("inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide",
      CAT[category] || "bg-slate-100 text-slate-700 border-slate-200", className)}>
      {category}
    </span>
  );
}
